/* Curvenna theme behaviour: replaces Broadcast's theme.js + Kaching + UpCart + Judge.me scripts. */
(function () {
  'use strict';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };
  var root = (window.cvTheme && window.cvTheme.routes.root) || '/';

  /* ---------- lazy images + scroll animations ---------- */
  function initImages(scope) {
    $$('img', scope).forEach(function (img) {
      var done = function () {
        img.classList.remove('is-loading');
        var f = img.closest('figure');
        if (f) f.classList.remove('is-loading');
      };
      if (img.complete) done(); else img.addEventListener('load', done, { once: true });
    });
    $$('[data-aos]', scope).forEach(function (el) { el.classList.add('aos-animate'); });
  }

  /* ---------- header ---------- */
  function initHeader() {
    $$('hover-disclosure').forEach(function (el) {
      el.addEventListener('mouseenter', function () { el.classList.add('is-visible'); el.setAttribute('aria-expanded', 'true'); });
      el.addEventListener('mouseleave', function () { el.classList.remove('is-visible'); el.setAttribute('aria-expanded', 'false'); });
    });
    $$('header-search-popdown').forEach(function (pd) {
      var d = $('details', pd);
      if (!d) return;
      d.addEventListener('toggle', function () {
        pd.classList.toggle('is-open', d.open);
        if (d.open) { var i = $('input[type=search]', pd); if (i) setTimeout(function () { i.focus(); }, 50); }
      });
      $$('[data-popdown-close], [data-popdown-underlay]', pd).forEach(function (b) {
        b.addEventListener('click', function (e) { e.preventDefault(); d.open = false; });
      });
    });
    var header = $('[data-header-sticky]');
    if (header) {
      var onScroll = function () { header.classList.toggle('js__header__stuck', window.scrollY > 0); };
      window.addEventListener('scroll', onScroll, { passive: true }); onScroll();
    }
  }

  /* ---------- mobile menu ---------- */
  function initMobileMenu() {
    var drawer = $('header-drawer');
    if (!drawer) return;
    var open = function () {
      drawer.classList.add('drawer--animated', 'is-open');
      $$('[data-drawer-toggle="hamburger"]').forEach(function (b) { b.setAttribute('aria-expanded', 'true'); });
      document.documentElement.setAttribute('data-scroll-locked', '');
    };
    var close = function () {
      drawer.classList.add('is-closing');
      setTimeout(function () { drawer.classList.remove('is-open', 'is-closing', 'drawer--animated'); }, 300);
      $$('[data-drawer-toggle="hamburger"]').forEach(function (b) { b.setAttribute('aria-expanded', 'false'); });
      document.documentElement.removeAttribute('data-scroll-locked');
    };
    $$('[data-drawer-toggle="hamburger"]').forEach(function (b) { b.addEventListener('click', open); });
    $$('[data-drawer-close], [data-drawer-underlay]', drawer).forEach(function (b) { b.addEventListener('click', close); });
    var pane = $('[data-sliderule-pane]', drawer);
    $$('[data-sliderule-open]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('data-sliderule-open'));
        var panel = p && $('[data-sliderule]', p);
        if (panel) { panel.classList.add('is-visible'); $$('[data-animates="1"]', panel).forEach(function (a) { a.classList.add('is-visible'); }); }
        if (pane) pane.setAttribute('data-sliderule-pane', '1');
      });
    });
    $$('[data-sliderule-close]', drawer).forEach(function (b) {
      b.addEventListener('click', function () {
        var p = document.getElementById(b.getAttribute('data-sliderule-close'));
        var panel = p && $('[data-sliderule]', p);
        if (panel) panel.classList.remove('is-visible');
        if (pane) pane.setAttribute('data-sliderule-pane', '0');
      });
    });
  }

  /* ---------- localization popouts ---------- */
  function initPopouts() {
    $$('popout-select').forEach(function (ps) {
      var t = $('[data-popout-toggle]', ps), list = $('[data-popout-list]', ps), input = $('[data-popout-input]', ps);
      if (!t || !list) return;
      t.addEventListener('click', function () {
        var v = !list.classList.contains('popout-list--visible');
        list.classList.toggle('popout-list--visible', v); t.setAttribute('aria-expanded', v);
      });
      $$('[data-popout-option]', ps).forEach(function (o) {
        o.addEventListener('click', function (e) {
          e.preventDefault();
          if (input) input.value = o.getAttribute('data-value');
          var f = ps.closest('form'); if (f) f.submit();
        });
      });
      document.addEventListener('click', function (e) { if (!ps.contains(e.target)) list.classList.remove('popout-list--visible'); });
    });
  }

  /* ---------- product gallery ---------- */
  function initGallery(scope) {
    $$('product-images', scope).forEach(function (pi) {
      var slides = $$('[data-slide]', pi), thumbs = $$('[data-thumb-link]', pi), idx = 0;
      if (!slides.length) return;
      var setHeight = function () { var h = slides[idx].offsetHeight; if (h) pi.style.setProperty('--height', h + 'px'); };
      var go = function (n) {
        n = (n + slides.length) % slides.length;
        slides.forEach(function (s, i) {
          s.classList.toggle('media--active', i === n);
          s.classList.toggle('media--hidden', i !== n);
        });
        thumbs.forEach(function (t, i) {
          var on = i === n;
          t.parentElement.classList.toggle('is-active', on);
          if (on) { t.setAttribute('aria-current', 'true'); var h = t.closest('[data-thumbs-slider]'); if (h) h.scrollTo({ left: t.parentElement.offsetLeft - 20, behavior: 'smooth' }); }
          else t.removeAttribute('aria-current');
        });
        idx = n; pi.setAttribute('data-active-media', slides[n].getAttribute('data-media-id'));
        setTimeout(setHeight, 30);
      };
      thumbs.forEach(function (t, i) { t.addEventListener('click', function (e) { e.preventDefault(); go(i); }); });
      $$('[data-button-prev]', pi).forEach(function (b) { b.addEventListener('click', function () { go(idx - 1); }); });
      $$('[data-button-next]', pi).forEach(function (b) { b.addEventListener('click', function () { go(idx + 1); }); });
      var x0 = null, list = $('[data-product-media-list]', pi);
      if (list) {
        list.addEventListener('touchstart', function (e) { x0 = e.touches[0].clientX; }, { passive: true });
        list.addEventListener('touchend', function (e) {
          if (x0 === null) return; var dx = e.changedTouches[0].clientX - x0; x0 = null;
          if (Math.abs(dx) > 40) go(idx + (dx < 0 ? 1 : -1));
        });
      }
      window.addEventListener('resize', setHeight);
      var first = $('img', slides[0]);
      if (first && !first.complete) first.addEventListener('load', setHeight, { once: true });
      setHeight();
    });
  }

  /* ---------- collapsibles (Broadcast collapsible-elements: animated height, single-open groups) ---------- */
  function initAccordions() {
    var mq = window.matchMedia('(max-width: 749px)');
    $$('details[data-collapsible]').forEach(function (d) {
      var body = $('[data-collapsible-body]', d), trig = $('[data-collapsible-trigger]', d);
      if (!body || !trig) return;
      var setStatic = function () {
        var off = d.getAttribute(mq.matches ? 'mobile' : 'desktop') === 'false';
        if (off) { d.setAttribute('disabled', ''); d.open = true; body.style.height = 'auto'; }
        else if (d.hasAttribute('disabled')) { d.removeAttribute('disabled'); d.open = false; body.style.height = ''; }
      };
      if (d.hasAttribute('desktop') || d.hasAttribute('mobile')) { setStatic(); mq.addEventListener('change', setStatic); }
      if (d.open && !d.hasAttribute('disabled')) body.style.height = 'auto';
      trig.addEventListener('click', function (e) {
        if (d.hasAttribute('disabled')) { e.preventDefault(); return; }
        e.preventDefault();
        var content = $('[data-collapsible-content]', d);
        if (d.open) {
          body.style.height = body.scrollHeight + 'px';
          requestAnimationFrame(function () { body.style.height = '0px'; });
          d.setAttribute('open', 'false');
          setTimeout(function () { d.removeAttribute('open'); }, 300);
        } else {
          var grp = d.closest('collapsible-elements[single="true"]');
          var scope = grp && grp.closest('.product__content') ? grp.closest('.product__content') : grp;
          if (scope) $$('details[data-collapsible][open]', scope).forEach(function (o) {
            if (o === d || o.hasAttribute('disabled')) return;
            var ob = $('[data-collapsible-body]', o); ob.style.height = ob.scrollHeight + 'px';
            requestAnimationFrame(function () { ob.style.height = '0px'; });
            o.setAttribute('open', 'false'); setTimeout(function () { o.removeAttribute('open'); }, 300);
          });
          d.setAttribute('open', 'true');
          body.style.height = (content ? content.scrollHeight : body.scrollHeight) + 'px';
          setTimeout(function () { if (d.getAttribute('open') === 'true') body.style.height = 'auto'; }, 320);
        }
      });
    });
  }

  /* ---------- cart API ---------- */
  function addItems(items) {
    // Shopify only records an add-to-cart (and the Meta pixel's AddToCart) when one request adds ONE item:
    // same sizes are merged into one line, different sizes are added one after the other.
    var merged = [];
    items.forEach(function (it) {
      var m = merged.filter(function (x) { return x.id === it.id; })[0];
      if (m) m.quantity += it.quantity; else merged.push({ id: it.id, quantity: it.quantity });
    });
    return merged.reduce(function (p, it) {
      return p.then(function () {
        return fetch(root + 'cart/add.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ items: [it] })
        }).then(function (r) { return r.json().then(function (j) { if (!r.ok) throw j; return j; }); });
      });
    }, Promise.resolve());
  }
  function changeLine(line, qty) {
    return fetch(root + 'cart/change.js', {
      method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); });
  }

  /* ---------- product form + bundle tiers ---------- */
  function initProductForms(scope) {
    $$('[data-cv-bundle]', scope).forEach(function (b) {
      $$('.kaching-bundles__bar', b).forEach(function (bar) {
        var radio = $('input[type=radio]', bar);
        bar.addEventListener('click', function (e) {
          if (e.target.closest('select')) return;
          $$('.kaching-bundles__bar', b).forEach(function (o) { o.classList.toggle('kaching-bundles__bar--selected', o === bar); });
          if (radio) radio.checked = true;
        });
      });
      $$('select[data-cv-item]', b).forEach(function (s) {
        s.addEventListener('change', function () {
          var o = s.options[s.selectedIndex]; s.setAttribute('data-value', o.getAttribute('data-value'));
        });
      });
    });
    $$('variant-selects', scope).forEach(function (vs) {
      var data = $('[data-cv-variants]', vs); if (!data) return;
      var variants = JSON.parse(data.textContent);
      vs.addEventListener('change', function () {
        var opts = $$('fieldset', vs).map(function (fs) { var c = $('input:checked', fs); return c ? c.value : null; });
        var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === opts[i]; }); });
        if (!v) return;
        var form = document.getElementById('product-form-' + vs.getAttribute('data-section'));
        if (form) form.querySelector('[name=id]').value = v.id;
        $$('[data-selected-value]', vs).forEach(function (el, i) { el.textContent = opts[i]; });
      });
    });
    $$('form[data-product-form]', scope).forEach(function (form) {
      form.addEventListener('submit', function (e) {
        e.preventDefault();
        var info = form.closest('product-info') || document;
        var bundle = $('[data-cv-bundle]', info), items = [];
        if (bundle) {
          var sel = $('.kaching-bundles__bar--selected', bundle) || $('.kaching-bundles__bar', bundle);
          $$('select[data-cv-item]', sel).forEach(function (s) { items.push({ id: Number(s.value), quantity: 1 }); });
        }
        if (!items.length) {
          var q = form.querySelector('[name=quantity]');
          items.push({ id: Number(form.querySelector('[name=id]').value), quantity: q ? Number(q.value) || 1 : 1 });
        }
        var btn = form.querySelector('[data-add-to-cart]');
        if (btn) btn.classList.add('is-loading');
        addItems(items).then(function () { return Cart.refresh(true); })
          .catch(function (err) {
            var m = info.querySelector('[data-cart-error-message]');
            if (m) { m.textContent = (err && (err.description || err.message)) || 'Error'; m.closest('.product__form__errors').classList.add('is-visible'); }
          })
          .finally(function () { if (btn) btn.classList.remove('is-loading'); });
      });
    });
  }

  /* ---------- quick add (product cards) ---------- */
  function initQuickAdd() {
    document.addEventListener('click', function (e) {
      var b = e.target.closest('[data-cv-quick-add]');
      if (!b) return;
      e.preventDefault();
      var handle = b.getAttribute('data-cv-quick-add');
      b.classList.add('is-loading');
      fetch(root + 'products/' + handle + '.js').then(function (r) { return r.json(); }).then(function (p) {
        b.classList.remove('is-loading');
        var avail = p.variants.filter(function (v) { return v.available; });
        if (p.variants.length === 1) return addItems([{ id: p.variants[0].id, quantity: 1 }]).then(function () { Cart.refresh(true); });
        QuickAdd.open(p, avail.length ? avail[0].id : p.variants[0].id);
      }).catch(function () { b.classList.remove('is-loading'); });
    });
  }
  var QuickAdd = {
    el: null,
    open: function (p, vid) {
      if (!this.el) {
        this.el = document.createElement('dialog');
        this.el.className = 'drawer product-quick-add cv-quick-add';
        document.body.appendChild(this.el);
        var self = this;
        this.el.addEventListener('click', function (e) { if (e.target === self.el || e.target.closest('[data-quick-add-modal-close]')) self.close(); });
      }
      var money = function (c) { return Cart.money(c); };
      var opts = p.variants.map(function (v) {
        return '<span class="radio__button"><input type="radio" name="cvqa" id="cvqa-' + v.id + '" value="' + v.id + '"' + (v.id === vid ? ' checked' : '') + (v.available ? '' : ' disabled') + '><label for="cvqa-' + v.id + '"><span class="option-title">' + v.title + '</span></label></span>';
      }).join('');
      var img = p.featured_image ? '<img src="' + p.featured_image + (p.featured_image.indexOf('?') > -1 ? '&' : '?') + 'width=600" alt="" style="width:100%;border-radius:var(--radius, 0);display:block">' : '';
      this.el.innerHTML = '<div class="drawer__inner product-quick-add__content" data-scroll-lock-scrollable><div class="product-quick-add__close-outer"><button class="product-quick-add__close drawer__close" aria-label="Close" data-quick-add-modal-close><svg aria-hidden="true" focusable="false" role="presentation" class="icon icon-cancel" viewBox="0 0 24 24"><path d="M6.758 17.243 12.001 12m5.243-5.243L12 12m0 0L6.758 6.757M12.001 12l5.243 5.243" stroke="currentColor" stroke-linecap="round" stroke-linejoin="round"/></svg></button></div>' +
        '<div class="product-quick-add__inner cv-quick-add__inner">' + img + '<p class="product__title heading-small cv-quick-add__title">' + p.title + '</p><p class="cv-quick-add__price">' + money(p.price) + '</p>' +
        '<div class="radio__fieldset"><legend class="radio__legend"><span class="radio__legend__option-name body-medium">' + p.options[0].name + '</span></legend><div class="radio__buttons">' + opts + '</div></div>' +
        '<button type="button" class="btn btn--large btn--solid btn--black cv-quick-add__btn" data-cv-qa-add><span class="btn__text">Add to cart</span></button></div></div>';
      var self = this;
      this.el.querySelector('[data-cv-qa-add]').addEventListener('click', function () {
        var c = self.el.querySelector('input[name=cvqa]:checked');
        addItems([{ id: Number(c.value), quantity: 1 }]).then(function () { self.close(); Cart.refresh(true); });
      });
      this.el.showModal();
    },
    close: function () { if (this.el && this.el.open) this.el.close(); }
  };

  /* ---------- cart drawer (UpCart look, native cart) ---------- */
  var Cart = {
    host: null, shadow: null,
    money: function (cents) {
      var fmt = (window.cvTheme && window.cvTheme.moneyFormat) || '£{{amount}}';
      var v = (cents / 100).toFixed(2);
      return fmt.replace(/\{\{\s*amount\s*\}\}/, v.replace(/\B(?=(\d{3})+(?!\d))/g, ',')).replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100));
    },
    init: function () {
      this.host = $('[data-cv-cart-host]');
      if (!this.host) return;
      this.shadow = this.host.attachShadow({ mode: 'open' });
      var tpl = $('[data-cv-cart-template]');
      this.render(tpl ? tpl.innerHTML : '');
      var self = this;
      document.addEventListener('click', function (e) {
        var t = e.target.closest('[data-cart-toggle]');
        if (t) { e.preventDefault(); self.open(); }
      });
      this.shadow.addEventListener('click', function (e) { self.onClick(e); });
      this.shadow.addEventListener('change', function (e) {
        var inp = e.target.closest('[data-cv-qty-input]');
        if (inp) { var li = inp.closest('[data-cv-line]'); self.change(Number(li.getAttribute('data-cv-line')), Math.max(0, parseInt(inp.value, 10) || 0)); }
      });
      document.addEventListener('keydown', function (e) { if (e.key === 'Escape') self.close(); });
    },
    render: function (html) {
      var wasOpen = this.isOpen(), self = this, LINK = /<link[^>]*rel="stylesheet"[^>]*>/;
      if (!this.root) {
        // The drawer stylesheet loads inside the shadow root after the page paints: keep the drawer hidden until it has loaded,
        // otherwise its unstyled close icon shows full-screen on page load. The <link> is created once, not on every render.
        this.host.style.display = 'none';
        var m = html.match(LINK);
        this.shadow.innerHTML = (m ? m[0] : '') + '<div data-cv-cart-root style="display:contents"></div>';
        this.root = this.shadow.querySelector('[data-cv-cart-root]');
        var link = this.shadow.querySelector('link[rel="stylesheet"]'), show = function () { self.host.style.display = ''; };
        if (link) { link.addEventListener('load', show); link.addEventListener('error', show); } else show();
      }
      this.root.innerHTML = html.replace(LINK, '');
      if (wasOpen) this.setOpen(true);
      this.startTimer();
    },
    isOpen: function () { var c = this.shadow && this.shadow.getElementById('CartPopup'); return !!(c && c.classList.contains('styles_active__')); },
    setOpen: function (on) {
      var c = this.shadow.getElementById('CartPopup'), bd = this.shadow.getElementById('UpcartPopupBackDrop');
      if (c) c.classList.toggle('styles_active__', on);
      if (bd) bd.classList.toggle('styles_active__', on);
      document.documentElement.style.overflow = on ? 'hidden' : '';
    },
    open: function () { this.setOpen(true); },
    close: function () { this.setOpen(false); },
    onClick: function (e) {
      var self = this;
      if (e.target.closest('[data-cv-cart-close]')) { e.preventDefault(); this.close(); return; }
      var q = e.target.closest('[data-cv-qty]');
      if (q) { var li = q.closest('[data-cv-line]'); this.change(Number(li.getAttribute('data-cv-line')), Number(q.getAttribute('data-cv-qty'))); return; }
      var up = e.target.closest('[data-cv-upsell-add]');
      if (up) {
        var sel = up.parentElement.querySelector('[data-cv-upsell-select]');
        up.textContent = '…';
        addItems([{ id: Number(sel.value), quantity: 1 }]).then(function () { self.refresh(true); });
      }
    },
    change: function (line, qty) { var self = this; changeLine(line, qty).then(function () { self.refresh(false); }); },
    refresh: function (openAfter) {
      var self = this, sid = this.host.getAttribute('data-section-id');
      return fetch(root + '?sections=' + encodeURIComponent(sid)).then(function (r) { return r.json(); }).then(function (j) {
        var doc = new DOMParser().parseFromString(j[sid], 'text/html');
        var tpl = doc.querySelector('[data-cv-cart-template]');
        self.render(tpl ? tpl.innerHTML : '');
        if (openAfter) self.open();
        return fetch(root + 'cart.js').then(function (r) { return r.json(); });
      }).then(function (cart) {
        $$('cart-count').forEach(function (c) { c.textContent = cart.item_count; c.setAttribute('data-cart-count', cart.item_count); });
      });
    },
    startTimer: function () {
      var el = this.shadow.querySelector('[data-cv-cart-timer]');
      if (!el) return;
      clearInterval(this._t);
      var mins = parseInt(el.textContent, 10) || 10, end;
      try { end = Number(sessionStorage.getItem('cvCartTimer')); } catch (e) { end = 0; }
      if (!end || end < Date.now()) { end = Date.now() + mins * 60000; try { sessionStorage.setItem('cvCartTimer', end); } catch (e) {} }
      var tick = function () {
        var s = Math.max(0, Math.round((end - Date.now()) / 1000));
        el.textContent = String(Math.floor(s / 60)).padStart(2, '0') + ':' + String(s % 60).padStart(2, '0');
      };
      tick(); this._t = setInterval(tick, 1000);
    }
  };

  /* ---------- reviews list ---------- */
  function initReviews() {
    $$('[data-cv-reviews]').forEach(function (w) {
      var per = Number(w.getAttribute('data-per-page')) || 5, items = $$('[data-cv-review]', w), page = 0;
      var pages = Math.max(1, Math.ceil(items.length / per)), nums = $('[data-cv-page-numbers]', w), nav = $('[data-cv-review-pages]', w);
      if (nav && pages < 2) nav.style.display = 'none';
      var show = function (p) {
        page = Math.min(Math.max(p, 0), pages - 1);
        items.forEach(function (it, i) { it.style.display = (i >= page * per && i < (page + 1) * per) ? '' : 'none'; });
        if (nums) {
          nums.innerHTML = '';
          // short pager like Judge.me: 1 2 3 … 113 (first, last, current ±1), not every page number
          var want = [0, pages - 1, page - 1, page, page + 1].concat(page < 3 ? [1, 2] : []).concat(page > pages - 4 ? [pages - 2, pages - 3] : []);
          var shown = want.filter(function (x, k) { return x >= 0 && x < pages && want.indexOf(x) === k; }).sort(function (x, y) { return x - y; });
          for (var j = 0; j < shown.length; j++) {
            var i = shown[j];
            if (j > 0 && i - shown[j - 1] > 1) { var gap = document.createElement('span'); gap.className = 'jm-text cv-page-gap'; gap.textContent = '…'; gap.style.cssText = 'padding:0 4px;align-self:center;'; nums.appendChild(gap); }
            var b = document.createElement('button'); b.type = 'button';
            b.className = 'jm-button jm-button--primary jm-pagination-controls__button jm-pagination-controls__button--page' + (i === page ? ' jm-pagination-controls__button--active' : '');
            b.style.cssText = i === page ? '--jm-btn-bg: var(--jm-review-widget-button-color); --jm-btn-border: var(--jm-review-widget-button-color); --jm-btn-color: var(--jm-review-widget-button-text-color); --jm-btn-border-radius: var(--jm-widget-border-radius-simplified);' : '--jm-btn-bg: transparent; --jm-btn-border: transparent; --jm-btn-color: var(--jm-review-widget-text-color); --jm-btn-border-radius: var(--jm-widget-border-radius-simplified);';
            b.innerHTML = '<span class="jm-text" style="--text-size: var(--jm-body-sm-size); --text-weight: var(--jm-body-sm-weight-default);">' + (i + 1) + '</span>';
            (function (n) { b.addEventListener('click', function () { show(n); }); })(i);
            nums.appendChild(b);
          }
        }
      };
      $$('[data-cv-page]', w).forEach(function (b) { b.addEventListener('click', function () { show(page + (b.getAttribute('data-cv-page') === 'next' ? 1 : -1)); }); });
      show(0);
      var modal = $('[data-cv-review-modal]', w);
      if (modal) {
        var step = function (n) { $$('[data-cv-step]', modal).forEach(function (st) { st.hidden = st.getAttribute('data-cv-step') !== String(n); }); };
        $$('[data-cv-rate]', modal).forEach(function (b) {
          b.addEventListener('click', function () {
            var n = Number(b.getAttribute('data-cv-rate'));
            $$('[data-cv-rate]', modal).forEach(function (o) { o.classList.toggle('is-on', Number(o.getAttribute('data-cv-rate')) <= n); });
            $('[data-cv-rating-input]', modal).value = n;
            setTimeout(function () { step(2); }, 250);
          });
        });
        $$('[data-cv-review-open]', w).forEach(function (b) { b.addEventListener('click', function () { if (!$('[data-cv-review-done]', modal)) step(1); modal.showModal(); }); });
        $$('[data-cv-review-close]', modal).forEach(function (b) { b.addEventListener('click', function () { modal.close(); }); });
        modal.addEventListener('click', function (e) { if (e.target === modal) modal.close(); });
        if ($('[data-cv-review-done]', modal) || /cv-review-form/.test(location.hash)) modal.showModal();
      }
    });
  }


  /* ---------- sticky add to cart: appears once the main button has scrolled above the screen ---------- */

  /* ---------- stars line from the Reviews list (rating block option) ---------- */
  function initRatingFromList() {
    var src = document.getElementById('cv_product_reviews');
    $$('[data-cv-rating-from-list]').forEach(function (el) {
      var n = src ? Number(src.getAttribute('data-cv-rv-count')) : 0, line = el.closest('.product__block') || el.parentNode;
      if (!n) { line.style.display = 'none'; return; }
      var fr = (document.documentElement.lang || '').indexOf('fr') === 0, avg = String(src.getAttribute('data-cv-rv-avg'));
      el.textContent = (fr ? avg.replace('.', ',') : avg) + ' | ' + n.toLocaleString(fr ? 'fr-CA' : 'en-GB') + (el.getAttribute('data-suffix') ? ' ' + el.getAttribute('data-suffix') : '');
    });
  }
  // theme editor: blocks are re-rendered without a page load, so fill the line again
  document.addEventListener('shopify:section:load', function () { initRatingFromList(); });
  document.addEventListener('shopify:block:select', function () { initRatingFromList(); });
  function initStickyATC() {
    var form = $('form[data-product-form]'), main = form && form.querySelector('[data-add-to-cart]');
    if (!form || !main) return;
    var info = form.closest('product-info') || document;
    var title = $('.product__title', info), img = $('.product__slide img', info);
    var bar = document.createElement('div');
    bar.className = 'cv-sticky-atc'; bar.setAttribute('aria-hidden', 'true');
    bar.innerHTML = '<div class="cv-sticky-atc__inner">' + (img ? '<img class="cv-sticky-atc__img" src="' + (img.currentSrc || img.src) + '" alt="">' : '') +
      '<div class="cv-sticky-atc__info"><div class="cv-sticky-atc__title">' + (title ? title.textContent.trim() : '') + '</div><div class="cv-sticky-atc__price" data-cv-sticky-price></div></div>' +
      '<button type="button" class="cv-sticky-atc__btn">Add to cart</button></div>';
    document.body.appendChild(bar);
    var setPrice = function () {
      var sel = $('.kaching-bundles__bar--selected', info), el = $('[data-cv-sticky-price]', bar);
      if (!el) return;
      if (sel) { var p = $('[data-cv-price]', sel), f = $('[data-cv-full]', sel); el.innerHTML = (p ? p.textContent.trim() : '') + (f ? '<s>' + f.textContent.trim() + '</s>' : ''); }
    };
    setPrice(); info.addEventListener('click', function () { setTimeout(setPrice, 50); });
    bar.querySelector('button').addEventListener('click', function () {
      if (form.requestSubmit) form.requestSubmit(); else form.dispatchEvent(new Event('submit', { cancelable: true }));
    });
    var footer = $('.footer-sections');
    var update = function () {
      var r = main.getBoundingClientRect(), fr = footer ? footer.getBoundingClientRect() : null;
      var show = r.bottom < 0 && !(fr && fr.top < window.innerHeight);
      bar.classList.toggle('is-visible', show); bar.setAttribute('aria-hidden', show ? 'false' : 'true');
    };
    window.addEventListener('scroll', update, { passive: true }); window.addEventListener('resize', update); update();
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.body.classList.add('is-loaded');
    initImages(document); initHeader(); initMobileMenu(); initPopouts(); initGallery(document);
    initAccordions(); initProductForms(document); initQuickAdd(); Cart.init(); initReviews(); initRatingFromList(); initStickyATC();
  });
  window.cvCart = Cart;
})();
